import React from 'react'
import styles from './Withdraw.module.scss'
import { Input } from 'components/Input/Input'
import { Button } from 'components/Button/Button'
import classnames from 'classnames'
import { WITHDRAW_DATA_MOCK } from '../consts'

type Props = {
    onSubmit?: (value: number | null) => void,
}

export function Withdraw(props: Props) {
    const [currentTag, setCurrentTag] = React.useState(null)
    const [withdraw, setWithdraw] = React.useState(0)

    function handleActiveTag(tag) {
        setCurrentTag(tag.id)
        setWithdraw(tag.value)
    }

    function handleChange(item) {
        setWithdraw(item.value)
        setCurrentTag(null)
    }

    function handleSubmit() {
        props.onSubmit(withdraw)
    }

    return (
        <div className={styles['wrapper']}>
            <div className={styles['tags']}>
                {WITHDRAW_DATA_MOCK.map((tag) => {
                    return (
                        <div className={
                            classnames({
                                [styles['tag']]: true,
                                [styles['tag_active']]: currentTag === tag.id,
                            })}
                            onClick={() => handleActiveTag(tag)}
                            key={tag.id}>
                            {tag.text}
                        </div>
                    )
                })}
            </div>
            <Input
                size='m'
                type='number'
                name='deposite'
                placeholder='$ Your price'
                onChange={handleChange}
                value={withdraw} />
            <div className={styles['button']}>
                <Button
                    size='s'
                    type='primary'
                    disabled={withdraw < 1}
                    onClick={handleSubmit}>
                    Deposit
                </Button>
            </div>
        </div>
    );
}

